var exports = {
  "kL": "x2b2fbebb--028e54--container",
  "DD": "x2b2fbebb--028e54--title",
  "UU": "x2b2fbebb--028e54--name",
  "VQ": "x2b2fbebb--028e54--ratings",
  "O0": "x2b2fbebb--028e54--rating",
  "VA": "x2b2fbebb--028e54--subtitle",
  "lI": "x2b2fbebb--028e54--fieldset",
};

module.exports = exports;
